import gql from 'graphql-tag';

const GET_PAGE_URL_ACTIVITY = gql`
  query getPageUrlActivity($appId: String!, $daysToTrack: Int) {
    getPageUrlActivity(appId: $appId, daysToTrack: $daysToTrack)
  }
`;

export default GET_PAGE_URL_ACTIVITY;
